import { ArrowForwardIcon, EditIcon } from '@chakra-ui/icons'
import { Box, Checkbox, Flex, IconButton, Text } from '@chakra-ui/react'
import { ScreenContext } from '@hb/react'
import { ActionButton, Expandable, SolidActionButton } from '@hb/react-web'
import { colors } from '@hb/shared'
import { PropsWithChildren, ReactElement, useContext } from 'react'

const iconDropShadowFilter = 'drop-shadow(0 0 1px rgba(0, 0, 0, 0.5))'

export const SignOnStagePanel = ({
  complete,
  title,
  isFirst,
  isLast,
  children,
  header,
  onOpen,
  buttonText,
}: PropsWithChildren<{
  complete: boolean
  title: string
  isFirst?: boolean
  isLast?: boolean
  onOpen?: () => void
  buttonText?: string
  header?: ReactElement
}>) => {
  const ButtonComponent = complete ? ActionButton : SolidActionButton
  const { isMobile } = useContext(ScreenContext)
  return (
    <Expandable
      initExpanded={!!children && !complete}
      borderBottomRadius={isLast ? 4 : 'none'}
      borderTopRadius={isFirst ? 4 : 'none'}
      overflow="hidden"
      bg="white"
      _dark={{ bg: 'gray.900' }}
      headerProps={{
        pr: 3,
        bg: 'gray.50',
        _dark: { bg: 'gray.800', borderColor: 'gray.700' },
      }}
      header={() => (
        <Flex
          w="100%"
          align="center"
          gap={2}
          px={isMobile ? 2 : 3}
          py={2}
          height={isMobile || header ? 'auto' : '52px'}
          borderColor="gray.200"
          _dark={{ borderColor: 'gray.700' }}
          flexFlow={isMobile ? 'column' : 'row'}>
          <Flex gap={2} align="center" w={isMobile ? '100%' : 'auto'}>
            <Checkbox colorScheme="green" size="lg" isChecked={complete} />
            <Text fontSize="lg" fontWeight={500}>
              {title}
            </Text>
          </Flex>
          {header ? (
            <Flex flex={1} minW="0">
              {header}
            </Flex>
          ) : null}
          {onOpen ? (
            <Flex ml={isMobile ? 0 : 'auto'} w={isMobile ? '100%' : 'auto'}>
              {buttonText ? (
                <ButtonComponent gap={2} size="sm" onClick={onOpen} w={isMobile ? '100%' : 'auto'}>
                  <Text>{buttonText}</Text>
                  {complete ? (
                    <EditIcon
                      width={4}
                      height={4}
                      color={complete ? colors.green.hex : 'white'}
                      filter={complete ? 'none' : iconDropShadowFilter}
                    />
                  ) : (
                    <ArrowForwardIcon
                      width={6}
                      height={6}
                      color="white"
                      filter={iconDropShadowFilter}
                    />
                  )}
                </ButtonComponent>
              ) : (
                <IconButton
                  aria-label={`Open ${title}`}
                  icon={
                    complete ? (
                      <EditIcon filter={iconDropShadowFilter} />
                    ) : (
                      <ArrowForwardIcon filter={iconDropShadowFilter} />
                    )
                  }
                  onClick={onOpen}
                  variant="solid"
                  bg="green.500"
                  color="white"
                />
              )}
            </Flex>
          ) : null}
        </Flex>
      )}>
      {children ? <Box px={2}>{children}</Box> : null}
    </Expandable>
  )
}
